export const en = {
    cancel: 'Cancel',
    date: 'Date',
    input_new_dates: 'Add new dates',
    placeholder_date: 'dd.mm.yyyy',
    save: 'Save',
};
